import React from 'react';
import ReactDOM from 'react-dom';
import store from './store';
import history from './shared/history';
import Root from './root';
import './assets/css/design-system.scss';
import './i18n';
import ErrorBoundaryWrapper from './shared/components/error-boundary-wrapper';

declare global {
  interface Window {
    analytics: any;
    smartlook: any;
    fwcrm: any;
    Froged: any;
    Beacon: any;
    Headway: any;
    churnkey: any;
    HighAdvocacy: any;
    Rewardful: any;
    rewardful: any;
    intercomSettings: any;
    Intercom: any;
    cello: any;
    Cello: any;
    appVersion: string;
    CelloAttribution: any;
    $crisp: any;
    CRISP_WEBSITE_ID: any;
    StripeCheckout: any;
    demoFeedbackTimeout: boolean;
    Paddle: any;
    tolt_referral: string;
    tolt: any;
    google: any;
  }
}

ReactDOM.render(
  <ErrorBoundaryWrapper>
    <Root store={store} history={history} />
  </ErrorBoundaryWrapper>,
  document.getElementById('root'),
);
